import styles from "./steps.module.css";

interface StepsProps<T> {
  steps: T[];
  current: number;
  goTo?: (current: number) => void; 
  [key: string]: any;
}

export function Steps<T>({ steps, current, goTo }: StepsProps<T>) {
  const renderSteps = () => {
    if (steps?.length > 0) {
      return steps.map((_: unknown, index: number) => {
        return (
          <div
            key={`Step-${index}`}
            data-testid={`step-${index}`}
            className={`${styles.Step} ${current === index ? styles.Active : ""}`}
            onClick={() => goTo ? goTo(index) : null}
          />
        )
      });
    }
  }

  return (
    <div data-testid="steps-component" className={styles.Wrapper}>
      {renderSteps()}
    </div>
  );
}
